import axios from "axios";
import { getToken, getUser } from "../Utils/Common";
import token_valid from "./TokenValid";

//get import data with pagination
const getImportData = async (offset, pageSize, filter) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();

    return axios
      .post(
        process.env.REACT_APP_API_URL +
          "/api/import/all/" +
          offset +
          "/" +
          pageSize,
        {
          productCode: filter._productCode ? filter._productCode.trim() : null,
          itemName: filter._itemName ? filter._itemName.trim() : null,
          brand: filter._brand ? filter._brand.trim() : null,
          addedBy: filter._addedBy ? filter._addedBy.trim() : null,
          unitType: filter._unitType ? filter._unitType.trim() : null,
          status: filter._status ? filter._status.trim() : null,
          categories:
            filter._category?.length === 0 || filter._category === null
              ? null
              : filter._category,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log(response);
        console.log("Response --", response.data.content);
        return response.data;
      })
      .catch(async (error) => {
        // return "Something went wrong...";
        console.log("get imports " + error);
        return "Something went wrong...";
      });
  }
};

//get all import data
const getAllImportData = async () => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(process.env.REACT_APP_API_URL + "/api/import/all", {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        console.log(response);
        console.log("Response all--", response.data);
        return response.data;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("get imports " + error);
        return "Something went wrong...";
      });
  }
};

//find import item by id
const getImportItemById = async (itemId) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(process.env.REACT_APP_API_URL + "/api/import/" + itemId, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        console.log(response);
        console.log("Response all--", response.data);
        return response.data;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("get imports " + error);
        return "Something went wrong...";
      });
  }
};

//Diactivate import item by id
const DiactivateItemById = async (itemId) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .put(
        process.env.REACT_APP_API_URL + "/api/import/diactive/" + itemId,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log(response);
        console.log("Response all--", response.data);
        return "Done";
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("get imports " + error);
        return "Error: " + error;
      });
  }
};

//get all categories
const getAllCategories = async () => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(process.env.REACT_APP_API_URL + "/api/import/category/all", {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        console.log(response);
        console.log("Response all--", response.data);
        return response.data;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("get imports " + error);
        return "Something went wrong...";
      });
  }
};

//get imports by category
const getImportsByCategory = async (cat_id) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL +
          "/api/import/items/by-category/" +
          cat_id,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log(response);
        console.log("Response all--", response.data);
        return response.data;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("get imports " + error);
        return "Something went wrong...";
      });
  }
};

//get categories by category id
const getCategoryById = async (cat_id) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(process.env.REACT_APP_API_URL + "/api/import/category/" + cat_id, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        console.log(response);
        console.log("Response all--", response.data);
        return response.data;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("get imports " + error);
        return "Something went wrong...";
      });
  }
};

// search import items
const searchImportItem = async (val) => {};

// const submitNewImportItem= async(values)=>{
//     let checkedCategory= await checkCategory(values);
// }

//check category availability
const checkCategory = async (values) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    console.log("values", values);

    let token = getToken();
    return axios
      .post(
        process.env.REACT_APP_API_URL + "/api/import/category/check",
        {
          category: values._importMCategory.trim(),
          subCat_1: values._subCat_1.trim(),
          subCat_2: values._subCat_2.trim(),
          subCat_3: values._subCat_3.trim(),
          subCat_4: values._subCat_4.trim(),
          subCat_5: values._subCat_5.trim(),
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then(async (response) => {
        console.log("Category", response.data);
        return response.data;
      })
      .catch((error) => {
        console.log("get imports " + error);
        return false;
      });
  }
};

//add new category
const addNewCategory = async (values) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .post(
        process.env.REACT_APP_API_URL + "/api/import/category/add",
        {
          category: values._importMCategory.trim(),
          subCat_1: values._subCat_1.trim(),
          subCat_2: values._subCat_2.trim(),
          subCat_3: values._subCat_3.trim(),
          subCat_4: values._subCat_4.trim(),
          subCat_5: values._subCat_5.trim(),
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then(async (response) => {
        console.log("Response", response.data);
        return response.data;
      })
      .catch((error) => {
        console.log("get imports " + error);
        return false;
      });
  }
};

//check the item availability
const checkItem = async (values, catId) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .post(
        process.env.REACT_APP_API_URL + "/api/import/check",
        {
          itemName: values._importName,
          brand: values._importBrand,
          catId: catId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then(async (response) => {
        console.log(response);
        return response.data;
        // setUserSession(response.data.token, response.data.user)
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("get imports " + error);
        return "Something went wrong...";
      });
  }
};

//create import item
const addIm_Item = async (values) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();

    //get user name
    let user = getUser();
    console.log("User" + user.username);

    return axios
      .post(
        process.env.REACT_APP_API_URL + "/api/import/add/item",
        {
          product_code: values._productCode ? values._productCode : "-",
          itemName: values._importName,
          unitType: values._importUnitType,
          categories: values._categories,
          refillRate: parseInt(values._refillRate),
          brand: values._importBrand,
          note: values._importNote,
          addedBy: user.username,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then(async (response) => {
        console.log(response);
        // setUserSession(response.data.token, response.data.user)
        return true;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("get imports " + error);
        return false;
      });
  }
};

//create import item
const updateIm_Item = async (values, id) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();

    //get user name
    let user = getUser();
    console.log("User" + user.username);

    return axios
      .put(
        process.env.REACT_APP_API_URL + "/api/import/update/" + id,
        {
          product_code: values._productCode ? values._productCode : "-",
          itemName: values._importName,
          unitType: values._importUnitType,
          categories: values._categories,
          refillRate: parseInt(values._refillRate),
          brand: values._importBrand,
          note: values._importNote,
          status: values._status,
          addedBy: user.username,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then(async (response) => {
        console.log(response);
        // setUserSession(response.data.token, response.data.user)
        return true;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("get imports " + error);
        return false;
      });
  }
};

//check imports items availability
const checkIm_Item = async (values) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();

    //get user name
    let user = getUser();
    console.log("User" + user.username);

    return axios
      .post(
        process.env.REACT_APP_API_URL + "/api/import/check_quantity",
        {
          values,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then(async (response) => {
        console.log(response);
        // setUserSession(response.data.token, response.data.user)
        return true;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("Check imports items qty" + error);
        return false;
      });
  }
};

//import bulk update
const importBulkUpdate = async (formData) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .post(
        process.env.REACT_APP_API_URL + "/api/import/bulk-import",
        formData,
        {
          headers: {
            // "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then(async (response) => {
        console.log(response);
        return "Success";
        // setUserSession(response.data.token, response.data.user)
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("imports bulk update " + error);
        return "Something went wrong...";
      });
  }
};

//get Export Category data with pagination by filetring
const getImCategoryDataByFilter = async (offset, pageSize, filter) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();

    console.log(token);

    return axios
      .post(
        process.env.REACT_APP_API_URL +
          "/api/import/category/search/" +
          offset +
          "/" +
          pageSize,
        {
          category: filter._category ? filter._category.trim() : null,
          subCat_1: filter._subCat_1 ? filter._subCat_1.trim() : null,
          subCat_2: filter._subCat_2 ? filter._subCat_2.trim() : null,
          subCat_3: filter._subCat_3 ? filter._subCat_3.trim() : null,
          subCat_4: filter._subCat_4 ? filter._subCat_4.trim() : null,
          subCat_5: filter._subCat_5 ? filter._subCat_5.trim() : null,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log(response);
        console.log("Response --", response.data.content);
        return response.data;
      })
      .catch(async (error) => {
        // return "Something went wrong...";
        console.log("get im Categories " + error);
        return "Something went wrong...";
      });
  }
};

//get import bill data with pagination
const getImportBillData = async (offset, pageSize, filter) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .post(
        process.env.REACT_APP_API_URL +
          "/api/import/bill/all/" +
          offset +
          "/" +
          pageSize,
        {
          ProductCode: filter._productCode ? filter._productCode.trim() : null,
          itemName: filter._itemName ? filter._itemName.trim() : null,
          shop: filter._shop ? filter._shop.trim() : null,
          addedBy: filter._addedBy ? filter._addedBy.trim() : null,
          billNo: filter._billNo ? filter._billNo.trim() : null,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log(response);
        console.log("Response --", response.data.content);
        return response.data;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("get imports " + error);
        return "Something went wrong...";
      });
  }
};

const getImportBillById = async (bill_id) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(process.env.REACT_APP_API_URL + "/api/import/bill/find/" + bill_id, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        console.log(response);
        console.log("Response --", response.data);
        return response.data;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("get imports " + error);
        return "Something went wrong...";
      });
  }
};

const getImportBillByIdToReturn = async (bill_id) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL + "/api/import/bill/return/" + bill_id,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log(response);
        console.log("Response --", response.data);
        return response.data;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("get imports " + error);
        return "Something went wrong...";
      });
  }
};

const getAllBills = async () => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(process.env.REACT_APP_API_URL + "/api/import/bill/all", {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        console.log(response);
        console.log("Response --", response.data);
        return response.data;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("get imports " + error);
        return "Something went wrong...";
      });
  }
};

//create import item
const addImportBill = async (billBody) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();

    return axios
      .post(process.env.REACT_APP_API_URL + "/api/import/bill/add", billBody, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then(async (response) => {
        console.log(response);
        return response.data;
      })
      .catch((error) => {
        // return "Something went wrong...";
        const apiError = error?.response?.data;
        const msg =
          apiError?.message || error.message || "Something went wrong";
        console.log("Bill Error " + msg);
        return msg;
      });
  }
};

// sending for approval
const importBillSendingForApproval = async (billId) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL + "/api/import/bill/approval/" + billId,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log(response);
        console.log("Response all--", response.data);
        return response.data;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("get Retail Bill Approval " + error);
        return "Something went wrong...";
      });
  }
};

//sending for approval
const approveImportBill = async (billId, approved) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL +
          "/api/import/bill/approved/" +
          billId +
          "/" +
          approved,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log(response);
        console.log("Response all--", response.data);
        const redirectUrl = `/template/im_bill_view/${billId}`;
        window.location.href = redirectUrl;
        return response.data;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("faild to approve bill " + error);
        return "Unable to approve the bill...";
      });
  }
};

// update import bill payments
const updateImportBillPayments = async (billId, values) => {
  // check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();

    // get user name
    let user = getUser();
    console.log("User" + user.username);

    return axios
      .post(
        process.env.REACT_APP_API_URL + "/api/import/billpayment/" + billId,
        values,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then(async (response) => {
        console.log(response);
        return true;
      })
      .catch((error) => {
        console.log("update sale bill payment error: " + error);
        return false;
      });
  }
};

//get sale bill payment by bill Id
const getImportBillPaymentsById = async (billId) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL + "/api/import/billpayment/" + billId,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log(response);
        console.log("Response all--", response.data);
        return response.data;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("get Sale Bill Payment " + error);
        return "Something went wrong...";
      });
  }
};

/////////////////////////////////////////////////
/////////////////////////////////////////////////import return bill

//create import item
const addImportReturnBill = async (billBody) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();

    return axios
      .post(
        process.env.REACT_APP_API_URL + "/api/import/return-bill/add",
        billBody,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then(async (response) => {
        console.log(response);
        return response.data;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("Bill Error " + error);
        return "Something went wrong...";
      });
  }
};

// sending for approval
const getImportReturnBillById = async (billId) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL + "/api/import/return-bill/" + billId,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log(response);
        console.log("Response all--", response.data);
        return response.data;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("get Retail Bill Approval " + error);
        return "Something went wrong...";
      });
  }
};

// sending for approval
const importReturnBillSendingForApproval = async (billId) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL +
          "/api/import/return-bill/approval/" +
          billId,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log(response);
        console.log("Response all--", response.data);
        return response.data;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("get Retail Bill Approval " + error);
        return "Something went wrong...";
      });
  }
};

//sending for approval
const approveImportReturnBill = async (billId, approved) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL +
          "/api/import/return-bill/approved/" +
          billId +
          "/" +
          approved,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log(response);
        console.log("Response all--", response.data);
        const redirectUrl = `/template/im_bill_return_view/${billId}`;
        window.location.href = redirectUrl;
        return response.data;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("faild to approve bill " + error);
        return "Unable to approve the bill...";
      });
  }
};
/////////////////////////////////////////////////

///////////////////////////////////////////////// stock update

//get stock update data with pagination
const getStockUpdateData = async (offset, pageSize, filter) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();

    return axios
      .post(
        process.env.REACT_APP_API_URL +
          "/api/stockintake/all/" +
          offset +
          "/" +
          pageSize,
        {
          productCode: filter._productCode ? filter._productCode.trim() : null,
          itemName: filter._itemName ? filter._itemName.trim() : null,
          brand: filter._brand ? filter._brand.trim() : null,
          addedBy: filter._addedBy ? filter._addedBy.trim() : null,
          billNo: filter._billNo ? filter._billNo.trim() : null,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log(response);
        console.log("Response --", response.data.content);
        return response.data;
      })
      .catch(async (error) => {
        // return "Something went wrong...";
        console.log("get imports " + error);
        return "Something went wrong...";
      });
  }
};

//get import stock update by id
const getImportStockUpdateById = async (intakeId) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(process.env.REACT_APP_API_URL + "/api/stockintake/" + intakeId, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        console.log(response);
        console.log("Response --", response.data);
        return response.data;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("get imports " + error);
        return "Something went wrong...";
      });
  }
};

//get import stock update by id
const getImportStockUpdateByImportId = async (importId) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL + "/api/stockintake/import/" + importId,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log(response);
        console.log("Response --", response.data);
        return response.data;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("get imports " + error);
        return "Something went wrong...";
      });
  }
};

//get import stock update by id
const getImportUpdateDurationByImportId = async (importId) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL +
          "/api/export/product/lastupdate/" +
          importId,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log(response);
        console.log("Response --", response.data);
        return response.data;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("get imports " + error);
        return "Something went wrong...";
      });
  }
};

//add stock intake
const addStockIntakeItem = async (values) => {
  console.log("Add Stock Intake Item", values);
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();

    //get user name
    let user = getUser();
    console.log("User" + user.username);

    return axios
      .post(
        process.env.REACT_APP_API_URL +
          "/api/stockintake/add/" +
          values._importitem.importId,
        {
          importId: values._importitem ? values._importitem.importId : null,
          intake_qty: values._importQty,
          discountPerItem: values._discount ? values._discount : 0.0,
          pricePerItem: values._pricePerItem,
          totalPrice: values._totalPrice,
          addedBy: user.username,
          billUnit: values._billUnit,
          prodUnitAmountPerBillUnit: values._itemUintsPerBillUnit,
          note: values._note ? values._note.trim() : null,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then(async (response) => {
        console.log(response);
        // setUserSession(response.data.token, response.data.user)
        return true;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("update stock intake " + error);
        return false;
      });
  }
};

//delete sub order according to the given Id
const deleteStockIntakeById = async (id) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .delete(process.env.REACT_APP_API_URL + "/api/stockintake/delete/" + id, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        console.log(response);
        return true;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("get Sale product " + error);
        return false;
      });
  }
};

// Parse uploaded Excel file and return reconciliation comparison report
const parseReconciliationFile = async (file) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    const formData = new FormData();
    formData.append("file", file);

    return axios
      .post(
        process.env.REACT_APP_API_URL + "/api/import/stock-reconciliation/parse",
        formData,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log("parseReconciliationFile error: " + error);
        return null;
      });
  }
};

// Submit per-line decisions after user reviews the reconciliation report
const submitReconciliationDecisions = async (submission) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .post(
        process.env.REACT_APP_API_URL + "/api/import/stock-reconciliation/submit",
        submission,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        return { success: true, message: response.data };
      })
      .catch((error) => {
        console.log("submitReconciliationDecisions error: " + error);
        return { success: false, message: "Submission failed. Please try again." };
      });
  }
};

const deleteImportBill = async (billId) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .delete(process.env.REACT_APP_API_URL + "/api/import/bill/" + billId, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then(() => true)
      .catch((error) => {
        console.error("deleteImportBill error:", error);
        return false;
      });
  }
};

const forceDeleteImportBill = async (billId) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .delete(process.env.REACT_APP_API_URL + "/api/import/bill/force/" + billId, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then(() => true)
      .catch((error) => {
        console.error("forceDeleteImportBill error:", error);
        return false;
      });
  }
};

// /////////////////////////////////////////////////////

export {
  addIm_Item,
  updateIm_Item,
  addImportBill,
  addNewCategory,
  checkCategory,
  DiactivateItemById,
  getAllBills,
  getAllCategories,
  getAllImportData,
  getCategoryById,
  getImportBillById,
  getImportBillData,
  getImCategoryDataByFilter,
  getImportData,
  getImportItemById,
  getImportsByCategory,
  getImportStockUpdateById,
  getImportStockUpdateByImportId,
  getStockUpdateData,
  searchImportItem,
  getImportUpdateDurationByImportId,
  addStockIntakeItem,
  importBillSendingForApproval,
  approveImportBill,
  addImportReturnBill,
  getImportReturnBillById,
  importReturnBillSendingForApproval,
  approveImportReturnBill,
  importBulkUpdate,
  getImportBillByIdToReturn,
  deleteStockIntakeById,
  updateImportBillPayments,
  getImportBillPaymentsById,
  checkIm_Item,
  parseReconciliationFile,
  submitReconciliationDecisions,
  deleteImportBill,
  forceDeleteImportBill,
};
